// extracted by mini-css-extract-plugin
export default {"bottomAd_box":"index_bottomAd_box_QZ3XX","bottomAd":"index_bottomAd_5-nf8"};